var storefrontApp = angular.module('storefrontApp');

storefrontApp.factory('authorizeNet', ['$q', function ($q) {

    var service = {
        createNonce: createNonce,
        convertToCardData: convertToCardData
    };

    return service;


    ////////////


    function createNonce(authData, cardData) {
        var deferred = $q.defer();
                
        var secureData = {
            authData: authData,
            cardData: cardData
        };

        Accept.dispatchData(secureData, acceptJsResponseHandler);

        return deferred.promise;


        function acceptJsResponseHandler(response) {
            // Attention Future Ben or anyone that works on this.  AcceptJS swallows any exceptions thrown in this block and reports it
            // back as the following error which is misleading:  E_WC_14: Accept.js encryption failed
            // https://stackoverflow.com/questions/49217727/e-wc-14-accept-js-encryption-failed

            try {
                // Handle any errors
                if (response.messages.resultCode === "Error") {
                    var i = 0;
                    var errorMessage = '';
                    while (i < response.messages.message.length) {
                        errorMessage += response.messages.message[i].code + ": " + response.messages.message[i].text + '<br />';
                        i = i + 1;
                    }
                    deferred.reject(errorMessage);
                    return;
                }

                var opaqueData = {
                    nonceDescriptor: response.opaqueData.dataDescriptor,
                    nonceValue: response.opaqueData.dataValue
                };

                deferred.resolve(opaqueData);
            } catch (e) {
                deferred.reject('The call to tokenize the credit card failed.');
            }
        }
    }

    function convertToCardData(cardFormData) {
        return {
            cardNumber: cardFormData.bankCardNumber,
            month: String(cardFormData.bankCardMonth),
            year: String(cardFormData.bankCardYear).slice(2), // angular-credit-cards always formats year as 4 digits
            cardCode: cardFormData.bankCardCVV2
        };
    }
}]);
